import React, { useEffect, useRef, useState } from "react";

/* ---------- Custom cursor (desktop only) ---------- */
export function CursorGlow() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const fine = window.matchMedia("(pointer: fine)").matches;
    if (!fine) return;
    setEnabled(true);

    let mouseX = -100, mouseY = -100;
    let ringX = -100, ringY = -100;
    let raf;

    const onMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${mouseX - 3}px, ${mouseY - 3}px)`;
      }
    };

    const onOver = (e) => {
      const interactive = e.target.closest("a, button, input, textarea, select, [role='button']");
      if (ringRef.current) {
        ringRef.current.classList.toggle("cursor-ring--active", !!interactive);
      }
    };

    const loop = () => {
      ringX += (mouseX - ringX) * 0.16;
      ringY += (mouseY - ringY) * 0.16;
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ringX - 18}px, ${ringY - 18}px)`;
      }
      raf = requestAnimationFrame(loop);
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("mouseover", onOver, { passive: true });
    raf = requestAnimationFrame(loop);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      cancelAnimationFrame(raf);
    };
  }, []);

  if (!enabled) return null;
  return (
    <>
      <div ref={dotRef} className="cursor-dot" aria-hidden="true" />
      <div ref={ringRef} className="cursor-ring" aria-hidden="true" />
    </>
  );
}

/* ---------- Film grain overlay ---------- */
export function GrainOverlay() {
  return <div className="gee-grain" aria-hidden="true" />;
}

/* ---------- Scroll progress bar ---------- */
export function ScrollProgress() {
  const barRef = useRef(null);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      const p = max > 0 ? (h.scrollTop / max) * 100 : 0;
      if (barRef.current) barRef.current.style.width = `${p}%`;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <div className="gee-progress" aria-hidden="true"><div ref={barRef} className="gee-progress-bar" /></div>;
}

/* ---------- Marquee strip ---------- */
export function MarqueeStrip({ items }) {
  const content = [...items, ...items];
  return (
    <div className="gee-marquee py-8 border-y border-[#e8eef4] bg-white select-none" aria-hidden="true" data-testid="marquee-strip">
      <div className="gee-marquee-track">
        {content.map((item, i) => (
          <span key={`${item}-${i < items.length ? "a" : "b"}-${i % items.length}`} className="gee-marquee-item">
            {item}
            <span className="gee-marquee-dot" />
          </span>
        ))}
      </div>
    </div>
  );
}
